import { apiInstance } from "shared/api";
import {
  ApiCardsBody,
  ApiCardsResponse,
  AttachResponse,
  PayoutResponse,
} from "./types";

export const getCards = (): Promise<ApiCardsResponse> =>
  apiInstance.get("/v1/cards").then((response) => response.data);

export const deleteCard = (id: string): Promise<ApiCardsResponse> =>
  apiInstance.delete(`/v1/cards/${id}`).then((response) => response.data);

export const changeCard = (
  id: string,
  body: ApiCardsBody,
): Promise<ApiCardsResponse> =>
  apiInstance.put(`/v1/cards/${id}`, body).then((response) => response.data);

export const attachCard = (): Promise<AttachResponse> => {
  return apiInstance.get(`/v1/cards/attach`).then((response) => response.data);
};

export const syncCard = (): Promise<PayoutResponse> => {
  return apiInstance.post(`/v1/cards/sync`).then((response) => response.data);
};
